
$(document).on('turbolinks:load', function () {
  if ($('body').is('[data-js-page-id="static_page#contact_support"]')) {
    console.log('static_page#contact_support page setup');
    ContactForm.init();
  }
});
